export enum OperatorType {
  BETWEEN = 'BETWEEN',
  CONTAINS = 'CONTAINS',
  ONE_OF = 'ONE_OF',
  ALL_OF = 'ALL_OF',
  // OTHER_CONTAINS = 'OTHER_CONTAINS',
  PROXIMITY = 'PROXIMITY'
}
